import React, { useEffect, useRef, useState } from 'react';

/**
 * 多选下拉（组织/小组/用户），支持级联筛选
 */
export default function MultiSelectDropdown({
  label,
  options,
  selectedValues,
  onSelectionChange,
  placeholder = '请选择...',
  formType,
  field,
  disabled = false,
  cascadeFilter = null,
  parentField = null, // 保留与原调用一致（未直接使用）
  parentValues = [],
  onSelectAll,
  onClearAll,
  style = {}
}) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredOptions = cascadeFilter ? cascadeFilter(options, parentValues) : options;

  const handleToggle = (value) => {
    if (disabled) return;
    const isSelected = selectedValues.includes(value);
    onSelectionChange(formType, field, value, !isSelected);
    setIsOpen(true);
  };

  const handleSelectAll = () => {
    if (disabled) return;
    onSelectAll(formType, field, filteredOptions.map((opt) => (typeof opt === 'string' ? opt : opt.name)));
    setIsOpen(true);
  };

  const handleClearAll = () => {
    if (disabled) return;
    onClearAll(formType, field);
    setIsOpen(true);
  };

  const selectedCount = selectedValues.length;
  const displayText =
    selectedCount === 0 ? placeholder : selectedCount === 1 ? selectedValues[0] : `已选择 ${selectedCount} 项`;

  return (
    <div style={{ marginBottom: 12, ...style }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          flexWrap: 'wrap'
        }}
      >
        <label
          style={{
            flex: '0 0 auto',
            margin: 0,
            fontSize: 14,
            fontWeight: 500,
            whiteSpace: 'nowrap',
            lineHeight: '36px'
          }}
        >
          {label}：
        </label>
        <div style={{ flex: '1 1 140px', minWidth: 0, position: 'relative' }} ref={dropdownRef}>
      <div
        style={{
          border: '1px solid #ddd',
          borderRadius: 4,
          padding: '8px 12px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          background: disabled ? '#f5f5f5' : '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          minHeight: 36,
          opacity: disabled ? 0.6 : 1
        }}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <span
          style={{
            color: selectedCount === 0 ? '#999' : '#333',
            fontSize: 14,
            flex: 1
          }}
        >
          {disabled ? '已选择推送给所有人' : displayText}
        </span>
        <span style={{ fontSize: 12, color: '#666' }}>{isOpen ? '▲' : '▼'}</span>
      </div>

      {isOpen && !disabled && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            right: 0,
            background: '#fff',
            border: '1px solid #ddd',
            borderRadius: 4,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            zIndex: 1000,
            maxHeight: 200,
            overflowY: 'auto'
          }}
        >
          <div
            style={{
              padding: '8px 12px',
              borderBottom: '1px solid #eee',
              display: 'flex',
              gap: 8
            }}
          >
            <button
              onClick={handleSelectAll}
              style={{
                padding: '4px 8px',
                fontSize: 12,
                background: '#1976d2',
                color: '#fff',
                border: 'none',
                borderRadius: 3,
                cursor: 'pointer'
              }}
            >
              全选
            </button>
            <button
              onClick={handleClearAll}
              style={{
                padding: '4px 8px',
                fontSize: 12,
                background: '#f44336',
                color: '#fff',
                border: 'none',
                borderRadius: 3,
                cursor: 'pointer'
              }}
            >
              清空
            </button>
          </div>

          {filteredOptions.map((option, index) => {
            const optionValue = typeof option === 'string' ? option : option.name;
            const optionLabel = typeof option === 'string' ? option : option.name;
            const optionOrg = typeof option === 'string' ? null : option.org;

            return (
              <div
                key={index}
                style={{
                  padding: '8px 12px',
                  cursor: 'pointer',
                  background: selectedValues.includes(optionValue) ? '#e3f2fd' : '#fff',
                  borderBottom: '1px solid #f0f0f0',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8
                }}
                onClick={() => handleToggle(optionValue)}
              >
                <input
                  type="checkbox"
                  checked={selectedValues.includes(optionValue)}
                  onChange={() => handleToggle(optionValue)}
                  style={{ margin: 0 }}
                />
                <span style={{ fontSize: 14, flex: 1 }}>{optionLabel}</span>
                {optionOrg && <span style={{ fontSize: 12, color: '#666' }}>({optionOrg})</span>}
              </div>
            );
          })}

          {filteredOptions.length === 0 && (
            <div
              style={{
                padding: '12px',
                textAlign: 'center',
                color: '#999',
                fontSize: 14
              }}
            >
              请先选择上级选项
            </div>
          )}
        </div>
      )}
        </div>
      </div>
    </div>
  );
}
